export default __webpack_public_path__ + "static/media/AnimalFeaturesTail_06.bf63081e.png";